import { css, styled } from 'styled-components';

const COLORS = [
  css`
    ${({ theme }) => theme.neutral_300}
  `,
  css`
    ${({ theme }) => theme.danger_500}
  `,
  css`
    ${({ theme }) => theme.warning_300}
  `,
  css`
    ${({ theme }) => theme.warning_200}
  `,
  css`
    ${({ theme }) => theme.success_200}
  `,
  css`
    ${({ theme }) => theme.success_300}
  `,
  css`
    ${({ theme }) => theme.primary_300}
  `,
];

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 24px;
  padding: 32px;
  background-color: ${({ theme }) => theme.neutral_200};
  border-radius: 16px;
`;

const ICON_WIDTH = 285;
const ICON_HEIGHT = Math.floor(ICON_WIDTH * 0.509);

export const Wrapper = styled.div<{ $isSpecialScore: boolean }>`
  position: relative;
  width: ${ICON_WIDTH}px;
  height: ${ICON_HEIGHT}px;

  svg {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    ${({ $isSpecialScore }) => css`
      path:nth-child(1) {
        stroke: ${COLORS[$isSpecialScore ? 1 : 0]};
      }
      path:nth-child(2) {
        stroke: ${COLORS[$isSpecialScore ? 2 : 1]};
      }
      path:nth-child(3) {
        stroke: ${COLORS[$isSpecialScore ? 3 : 2]};
      }
      path:nth-child(4) {
        stroke: ${COLORS[$isSpecialScore ? 4 : 3]};
      }
      path:nth-child(5) {
        stroke: ${COLORS[$isSpecialScore ? 5 : 4]};
      }
      path:nth-child(6) {
        stroke: ${COLORS[$isSpecialScore ? 6 : 5]};
      }
    `}
  }
`;

export const ScoreWrapper = styled.div<{ $score: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;

  .score {
    color: ${({ $score }) => COLORS[$score]};
  }
`;

const POINTER_POSITIONS = [17, 48, 76, 104, 132, 163, 163];
const POINTER_BORDER = '8px';

export const PoiterWrapper = styled.div<{ $score: number }>`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: calc(${ICON_WIDTH}px - ${POINTER_BORDER});
  height: calc(${ICON_HEIGHT * 2}px - ${POINTER_BORDER});
  pointer-events: none;
  margin: calc(${POINTER_BORDER} / 2);
  transform: rotate(${({ $score }) => POINTER_POSITIONS[$score]}deg);

  .pointer {
    position: absolute;
    box-sizing: content-box;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: white;
    top: calc(50% - 15px);
    left: calc(0% - 15px);
    transition: 200ms ease-out;
    border: ${POINTER_BORDER} solid ${({ $score }) => COLORS[$score]};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  .info-text {
    width: 100%;
    min-height: 3lh;
    text-align: center;
  }
`;

export const AnchorStyle = styled.p`
  color: ${({ theme }) => theme.primary_300};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;
